export enum FormatDateEnum {
  DDMMYYYY = 'dd/MM/yyyy',
  YYYYMMDD = 'yyyy/MM/dd'
}
